import { useQuery } from '@tanstack/react-query';
import { useNavigate, useParams } from 'react-router-dom';
import { Loading } from '../../../components/Loading';
import { BreadcrumbGroup } from '@cloudscape-design/components';
import { getScenarioDetails } from '../../../common/api/scenarios';
import { ScenarioView } from './scenario';

export default function View() {
  const { scenarioUuid } = useParams();
  const navigate = useNavigate();

  const getQuery = useQuery({
    queryKey: ['scenarios', scenarioUuid],
    queryFn: () => (scenarioUuid ? getScenarioDetails(scenarioUuid) : null),
    enabled: !!scenarioUuid,
    staleTime: 0,
    gcTime: 0,
  });

  const scenario = getQuery.data;
  const event = scenario?.event;

  return (
    <div className="bg-[#101c2c] text-white font-sans p-4">
      <div className="mb-4">
        <BreadcrumbGroup
          items={[
            { text: 'Manage', href: '/manage' },
            { text: 'Events', href: '/manage/events' },
            { text: event?.name ?? '...', href: `/manage/events/${event?.eventUuid}` },
            { text: scenario?.name ?? '...', href: `/manage/scenarios/${scenario?.scenarioUuid}` },
          ]}
          onFollow={(e) => {
            e.preventDefault();
            navigate(e.detail.href);
          }}
        />
      </div>
      {getQuery.isLoading || !getQuery.data || !scenario ? (
        <Loading />
      ) : (
        <ScenarioView scenario={scenario} refetch={getQuery.refetch} />
      )}
    </div>
  );
}
